import styled from '@emotion/styled';
import { AppBar, Grid } from '@mui/material';
import { colors } from 'theme/colors';

const StyledAppBar = styled(AppBar)`
  height: 64px;
  background-color: ${colors.white};
  border-bottom: 1px solid ${colors.blue200};
`;

const StyledGridLinks = styled(Grid)`
  margin-left: 20px;
  justify-content: flex-end;
  margin-right: 30px;

  & > div.MuiGrid-item {
    position: relative;
    margin: 0 20px;
    padding: 37px 10px 11px;
    border-radius: 100px 100px 0 0;

    & > a {
      display: block;
      width: 100%;
      height: 29px;
      text-decoration: none;
    }

    & > a.active-nav-item:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background: ${colors.blue600};
      height: 5px;
      border-radius: 10px 10px 0 0;
    }
  }
`;

export { StyledAppBar, StyledGridLinks };
